import type { Message } from "../../types/message";
import AudioMessage from "./audio-message";
import FileMessage from "./file-message";
import ImageMessage from "./image-message";
import StickerMessage from "./sticker-message";
import TextMessage from "./text-message";
import VideoMessage from "./video-message";
import LocationMessage from "./location-message";

export default function MessageRenderer({ message }: { message: Message }) {
  switch (message.type) {
    case "image":
      return <ImageMessage message={message} />;
    case "sticker":
      return <StickerMessage message={message} />;
    case "audio":
      return <AudioMessage message={message} />;
    case "video":
      return <VideoMessage message={message} />;
    case "file":
      return <FileMessage message={message} />;
    case "location":
      return <LocationMessage message={message} />;
    default:
      return <TextMessage message={message} />;
  }
}
